import { Link } from 'react-router-dom';
import { Menu, X, LayoutDashboard } from 'lucide-react';
import { Button } from './ui/button';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  return (
    <header className="border-b border-border bg-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="text-2xl font-bold text-foreground tracking-tight">FashionSpyder</Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link to="/gallery" className="text-muted-foreground hover:text-foreground font-medium text-sm transition-colors whitespace-nowrap">Gallery</Link>
            <Link to="/ai-matchmaker" className="text-muted-foreground hover:text-foreground font-medium text-sm transition-colors whitespace-nowrap">AI Matchmaker</Link>
            <Link to="/pricing" className="text-muted-foreground hover:text-foreground font-medium text-sm transition-colors whitespace-nowrap">Pricing</Link>
            {!user && (
              <>
                <span className="w-px h-4 bg-border flex-shrink-0" />
                <Link to="/for-talent" className="text-[hsl(var(--primary))] hover:opacity-75 font-medium text-sm transition-opacity whitespace-nowrap">For Talent</Link>
              </>
            )}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            {user ? (
              <>
                <Link to="/dashboard" className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap">
                  <LayoutDashboard className="w-4 h-4" /> Dashboard
                </Link>
                <div className="flex items-center gap-2">
                  {user.picture_url ? (
                    <img src={user.picture_url} alt={user.full_name} className="w-8 h-8 rounded-full object-cover" />
                  ) : (
                    <div className="w-8 h-8 bg-foreground text-background flex items-center justify-center text-xs font-bold rounded-full">
                      {(user.full_name || 'U')[0].toUpperCase()}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground font-medium transition-colors whitespace-nowrap">
                  Member Login
                </Link>
                <Link to="/register">
                  <Button className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary)/0.88)] text-white border-0 font-medium px-5 py-2 h-auto rounded-none text-sm gap-1.5 whitespace-nowrap">
                    Get Started <span className="opacity-80">→</span>
                  </Button>
                </Link>
              </>
            )}
          </div>

          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2">
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden border-t border-border bg-white">
          <div className="px-6 py-8 space-y-6">
            <Link to="/gallery" onClick={() => setMobileMenuOpen(false)} className="block text-foreground font-medium">Gallery</Link>
            <Link to="/ai-matchmaker" onClick={() => setMobileMenuOpen(false)} className="block text-foreground font-medium">AI Matchmaker</Link>
            <Link to="/pricing" onClick={() => setMobileMenuOpen(false)} className="block text-foreground font-medium">Pricing</Link>
            {!user && (
              <Link to="/for-talent" onClick={() => setMobileMenuOpen(false)} className="block text-[hsl(var(--primary))] font-medium">For Talent</Link>
            )}
            <div className="pt-4 border-t border-border space-y-3">
              {user ? (
                <>
                  <Link to="/dashboard" className="block text-foreground font-medium">Dashboard</Link>
                  <button onClick={logout} className="text-sm text-muted-foreground">Sign Out</button>
                </>
              ) : (
                <>
                  <Link to="/login" className="block text-muted-foreground font-medium">Member Login</Link>
                  <Link to="/register"><Button className="w-full bg-[hsl(var(--primary))] text-white border-0 rounded-none">Get Started</Button></Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
